import {
  BrandKit,
  defaultBrandKit,
} from "@redotech/redo-content-builder-common/brand-kit";
import { createContext, Dispatch, SetStateAction } from "react";
import { ReviewsFormForm } from "./review-form-types";

export const ReviewFormContext = createContext<ReviewsFormForm | undefined>(
  undefined,
);

export const BrandKitContext = createContext<BrandKit>(defaultBrandKit);

export const THANK_YOU_UPSELL_PAGE = "thank-you-upsell-page";
export type THANK_YOU_UPSELL_PAGE = typeof THANK_YOU_UPSELL_PAGE;

export interface ReviewFormSelection {
  selectedPageIndex: number | THANK_YOU_UPSELL_PAGE;
  selectedElementIndex: number | null;
}
export const ReviewFormSelectionContext = createContext<ReviewFormSelection>({
  selectedPageIndex: 0,
  selectedElementIndex: null,
});

export const SetReviewFormSelectionContext = createContext<
  Dispatch<SetStateAction<ReviewFormSelection>>
>(() => {});

export const UsedSemanticTagsContext = createContext<string[]>([]);

export interface ProductBeingReviewed {
  imageUrl: string;
  title: string;
  purchaseDate?: Date;
  variantTitle?: string;
  variantImageUrl?: string;
}
export const exampleProduct: ProductBeingReviewed = {
  imageUrl: "https://placehold.co/800x800?text=Product+image",
  variantImageUrl: "https://placehold.co/800x800?text=Variant+image",
  title: "Product title",
  variantTitle: "Variant title",
  purchaseDate: new Date(),
};
export const ProductBeingReviewedContext =
  createContext<ProductBeingReviewed>(exampleProduct);

export interface DiscountContext {
  formattedDiscountString: string;
  discountCode: string;
}
export const DiscountContext = createContext<DiscountContext | null>(null);
